import {login,getInfo,logout} from "@/assets/js/modules/userApi"
import {getToken,setToken,removeToken} from "@/assets/js/modules/auth"
import router, {resetRouter} from "@/router"

const state = {
    UserId: "",
    Token: getToken(),
    Avatar: "",
    Name: "",
    JobNo: "",
    Level: "",
    NickName: ""
}

const mutations = {
    SET_TOKEN: (state,Token)=>{
        state.Token = Token;
    }
}

const actions = {
    // user/login
    login({commit},userInfo){
        const {JobNo,Pwd} = userInfo;
        return new Promise((resolve, reject) => {
        login({ JobNo: JobNo.trim(), Pwd: Pwd }).then(response => {
            const data = response.data.Data;
            commit('SET_TOKEN', data.TokenInfo.Access_Token);
            setToken(data.TokenInfo.Access_Token,data.TokenInfo.Expires_In);
            resolve(data);
        }).catch(error => {
            console.log(error);
            reject(error)
        })
      }) 
    },
    // user/logout
    logout({commit,state}){
        commit('SET_TOKEN',"");
        removeToken();
        resetRouter();
    },
     // remove token
    resetToken({ commit }) {
        return new Promise(resolve => {
        commit('SET_TOKEN', '')
        removeToken()
        resolve()
        })
    },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/user.js